import { IconProps } from "@design-system/types";

export function LogoIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="304"
      height="49"
      viewBox="0 0 304 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M162.176 1.02179H152.56V48.64H162.176V1.02179Z" fill="white" />
      <path
        d="M115.036 1.02179V48.6463H124.652V17.5021L147.657 43.1215V26.3583L124.652 1.02179H115.036Z"
        fill="white"
      />
      <path
        d="M71.8735 1.02179V48.6463H109.492V39.0234H81.4965V10.6448H109.492V1.02179H71.8735Z"
        fill="white"
      />
      <path d="M106.833 19.7963H86.3679V29.413H106.833V19.7963Z" fill="white" />
      <path
        d="M242.177 10.5505L250.844 28.1685H233.603L242.177 10.5505ZM235.891 1.02179L220.392 36.7418L225.244 48.64L229.7 37.6846H254.628L259.034 48.64H269.323L248.657 1.02179H235.891Z"
        fill="white"
      />
      <path
        d="M259.612 1.02179V10.6448H274.565V48.6463H284.094V10.6448H294.094L304 1.02179H259.612Z"
        fill="white"
      />
      <path
        d="M185.866 1.02179L165.199 48.6463H175.294L179.675 37.6909H199.21L195.483 28.1685H183.578L192.246 10.5505L209.009 48.6463H219.292L198.914 1.78861L198.625 1.02179H185.866Z"
        fill="white"
      />
      <path
        d="M10.7355 20.4626C9.42811 19.2621 8.68015 17.5776 8.68015 15.7171C8.68015 12.1407 11.5903 9.23057 15.1667 9.23057H26.449L26.5873 9.13628L38.5924 0.556702H15.1604C6.80081 0.556702 0 7.35751 0 15.7171C0 19.4004 1.31994 22.8573 3.62039 25.5538L10.7355 20.4689V20.4626Z"
        fill="white"
      />
      <path
        d="M53.602 0.556702C49.8999 0.556702 46.2921 1.70064 43.2688 3.83139L35.2549 9.48198L7.91968 29.0296C8.00767 29.0799 8.09567 29.1302 8.18366 29.1804C10.3898 30.3244 12.7846 30.8901 15.1668 30.8901C18.234 30.8901 21.2825 29.9536 23.8972 28.1119L62.9987 0.556702H53.5957H53.602Z"
        fill="white"
      />
      <path
        d="M55.8269 28.9982C57.1343 30.1987 57.8822 31.8832 57.8822 33.7437C57.8822 37.32 54.9721 40.2302 51.3957 40.2302H40.1134L39.9751 40.3245L27.97 48.9041H51.3894C59.749 48.9041 66.5498 42.1032 66.5498 33.7437C66.5498 30.0604 65.2299 26.6034 62.9294 23.907L55.8143 28.9919L55.8269 28.9982Z"
        fill="white"
      />
      <path
        d="M12.9607 48.9103C16.6628 48.9103 20.2706 47.7664 23.2939 45.6294L31.3078 39.9788L58.6431 20.4312C58.5551 20.3809 58.4671 20.3306 58.3791 20.2803C56.1729 19.1364 53.7781 18.5707 51.396 18.5707C48.3287 18.5707 45.2803 19.5072 42.6655 21.3488L3.55774 48.9103H12.9607Z"
        fill="white"
      />
    </svg>
  );
}
